import React, { useState, useEffect } from 'react';
import { Home, Calendar, Menu, X, Users, Stethoscope } from 'lucide-react';

interface SidebarProps {
  currentPage: string;
  onPageChange: (page: string) => void;
  user: {
    role: 'paciente' | 'nutricionista';
    name: string;
    email: string;
  };
}

const Sidebar: React.FC<SidebarProps> = ({ currentPage, onPageChange, user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavClick = (page: string) => {
    onPageChange(page);
    if (isMobile) {
      setIsOpen(false);
    }
  };

  const getSidebarClasses = () => {
    const baseClasses = 'sidebar bg-success text-white d-flex flex-column';
    if (!isMobile) return baseClasses;
    return `${baseClasses} ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`;
  };

  return (
    <>
      {isMobile && (
        <button 
          className="hamburger-btn"
          onClick={toggleMenu}
          aria-label="Menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      )}

      {isMobile && isOpen && (
        <button 
          type="button"
          className="sidebar-overlay border-0 bg-transparent" 
          onClick={() => setIsOpen(false)}
          style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1040}}
        />
      )}

      <div className={getSidebarClasses()}>
        <div className="border-bottom border-light border-opacity-25" style={{height: '90px'}}>
          <img 
            src="/logo2.png" 
            alt="Logo" 
            style={{width: '100%', height: '90px', objectFit: 'contain', backgroundColor: 'white', display: 'block'}}
          />
        </div>
        <nav className="sidebar-nav flex-grow-1 py-3">
          <button 
            className={`nav-item btn btn-link text-white text-decoration-none d-flex align-items-center gap-3 w-100 text-start px-4 py-3 border-0 justify-content-start ${currentPage === 'inicio' ? 'bg-white bg-opacity-10' : ''}`}
            onClick={() => handleNavClick('inicio')}
          >
            <Home size={20} />
            <span>Início</span>
          </button>
          <button 
            className={`nav-item btn btn-link text-white text-decoration-none d-flex align-items-center gap-3 w-100 text-start px-4 py-3 border-0 justify-content-start ${currentPage === 'pacientes' ? 'bg-white bg-opacity-10' : ''}`}
            onClick={() => handleNavClick('pacientes')}
          >
            <Users size={20} />
            <span>Pacientes</span>
          </button>
          <button 
            className={`nav-item btn btn-link text-white text-decoration-none d-flex align-items-center gap-3 w-100 text-start px-4 py-3 border-0 justify-content-start ${currentPage === 'consultas' ? 'bg-white bg-opacity-10' : ''}`}
            onClick={() => handleNavClick('consultas')}
          >
            <Stethoscope size={20} />
            <span>Consultas</span>
          </button>
          <button 
            className={`nav-item btn btn-link text-white text-decoration-none d-flex align-items-center gap-3 w-100 text-start px-4 py-3 border-0 justify-content-start ${currentPage === 'agendamento' ? 'bg-white bg-opacity-10' : ''}`}
            onClick={() => handleNavClick('agendamento')}
          >
            <Calendar size={20} />
            <span>Agenda</span>
          </button>

        </nav>
      </div>
    </>
  );
};

export default Sidebar;